// extracted by mini-css-extract-plugin
export default {"wrapper":"Posts_wrapper__nmx89","content":"Posts_content__8gX0c","postListView":"Posts_postListView__rMo-H","postMapView":"Posts_postMapView__Kdos8"};